
import { qidaApi } from 'yxt-biz-pc/packages/api';

// 获取企业装修信息
export const getAllNavTitle = () => {
  return qidaApi.get('user/nav/code/name');
};
